module.exports = __webpack_public_path__ + "static/favicon-3ef088ca3183ab784ee06c0aed9d392a.ico";